import React, { useState, useEffect } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { baseURL, baseURLV1, imageURL, privilegeURLV2 } from "../../../service/API.js";
import Switch from "@material-ui/core/Switch";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  headerSortingClasses,
  toAbsoluteUrl
} from "../../../../_metronic/_helpers"
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import SVG from 'react-inlinesvg'
import { Modal, Button } from 'react-bootstrap'
import Pagination2 from "@material-ui/lab/Pagination";
import ReactLoading from "react-loading";
import * as XLSX from 'sheetjs-style'

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 300,
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
  noLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  inputColor: {
    backgroundColor: "#F4F6F9",
    borderRadius: "5px",
    borderWidth: "0",
  },
}));

export const CreateTargetPrivilege = (props) => {
  const intl = useIntl();
  const suhbeader = useSubheader();
  const classes = useStyles();
  suhbeader.setTitle(intl.formatMessage({ id: "###", defaultMessage: "Create Privilege Target Group" }));
  const history = useHistory();
  const [titleEN, setTitleEN] = useState('');
  const [titleTH, setTitleTH] = useState('');
  const [PrivilegeID, setPrivilegeID] = useState('');


  const [start_date, setStart_date] = useState(null);
  const [end_date, setEnd_date] = useState(null);
  const [listGroup2, setListGroup2] = useState([]);
  const [symbolsArr] = useState(["e", "E", "+", "-"])
  const [listPrivilege, setListPrivilege] = useState([]);
  const [target, setTarget] = useState(null);
  const [listTarget, setListTarget] = useState([]);

  const [listValue, setListValue] = useState([]);
  const [showListValue, setShowListValue] = useState(false)
  const [showDate, setShowDate] = useState(false)
  const [is_active, setIs_active] = useState(true);
  const [is_loading, setIs_loading] = useState(false);
  const [conditions, setConditions] = useState([]);
  const [memberData, setMemberData] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const [limit, setLimit] = useState(10);
  const [totalSize, setTotalSize] = useState(100);
  const [fixedlist, setfixedList] = useState([
    {
      id: '-',
      created_at: '-',

      key: 'project_id',
      option: null,
      value: [],
      label: 'Project id',
      updated_at: '-',

    },
    {
      id: '-',
      created_at: '-',

      key: 'brand_id',
      option: null,
      value: [],
      label: 'Brand id',
      updated_at: '-',

    }
  ])
  const [page, setPage] = useState(1);
  const [privilege, setPrivilege] = useState(0);

  const [projectList, setProjectList] = useState([])
  const [brandList, setBrandtList] = useState([])
  const [show, setshow] = useState(false)
  const [show2, setshow2] = useState(false)
  const [info, setInfo] = useState(false)
  const [popupTable, setPopupTable] = useState([])

  const exportExcel = async () => {
    let rows = []
    let temp2 = []
    //let headers = ['USER ID','FIRSTNAME','LASTNAME','EMAIL','DIMENSION','GENDER','BRAND','PROJECT NAME','PROJECT TYPE','FIRST APPROVE DATE']
    let headers = []
    let data2 = {
      USER_ID: groupName.key,
      FIRSTNAME: groupName.label,
      LASTNAME: groupName.label,
      EMAIL: groupName.label,
      DIMENSION: groupName.label,
      GENDER: getShowsplit(value),
      BRAND: start_date,
      PROJECT_NAME: end_date,
      PROJECT_TYPE: is_active,
      FIRST_APPROVE_DATE: is_active,
    }
    await popupTable.map(item => {
      rows.push({
        USER_ID: item.user_id,
        FIRSTNAME: item.firstname,
        LASTNAME: item.lastname,
        EMAIL: item.email,
        DIMENSION: item.dimension,
        GENDER: item.gender,
        BRAND: item.brand,
        PROJECT_NAME: item.project_name,
        PROJECT_TYPE: item.project_type,
        FIRST_APPROVE_DATE: item.first_approve_date,
      })
    })
    headers = Object.keys(rows[0])
    rows.map(item => {
      let data = []
      headers.map(item2 => {

        data.push(item[item2])
      })

      temp2.push(data)
    })
    const datas = [headers, ...temp2]
    const fileName = `export-ap.xlsx`
    const ws = (XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([[]]))
    const wb = (XLSX.WorkBook = XLSX.utils.book_new())
    const listHeader = ['A1', 'B1', 'C1', 'D1', 'E1', 'F1', 'G1', 'H1', 'I1', 'J1']
    XLSX.utils.sheet_add_aoa(ws, datas)
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
    listHeader.map(item => {
      ws[item].s = {
        border: {
          top: {
            style: 'medium',
            color: '000000'
          },
          bottom: {
            style: 'medium',
            color: '000000'
          },
          left: {
            style: 'medium',
            color: '000000'
          },
          right: {
            style: 'medium',
            color: '000000'
          },
        },
        alignment: {
          horizontal: "center"
        },
        font: {
          name: 'angsana new',
          sz: 18,
          bold: true,
        },
        fill: {
          fgColor: {
            rgb: "FFAB00"
          }
        }
      };
    })

    let wscols = [
      { width: 40 },
      { width: 15 },
      { width: 15 },
      { width: 25 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 25 },
      { width: 25 },
      { width: 25 },
      { width: 25 },
    ];
    ws["!cols"] = wscols;

    XLSX.writeFile(wb, fileName)
  }
  const getListTarget = async () => {
    const apiUrls = `${baseURLV1}/targetGroup?page=1&limit=1000`;
    let token = localStorage.getItem("token");

    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        // console.log(res.data.data)
        setListTarget(res.data.data)
      })
      .catch((err) => {
        if (err.response) {

        }
      });
  };
  const handleClose = () => {
    setshow(false)
  }

  const handleClose2 = () => {
    setshow2(false)
  }

  const handlePageChange = (event, value) => {
    setPage(value);
    //getData(value, limit, search);
  };
  const getListPrivilege = async () => {
    axios({
      method: "get",
      url: `${privilegeURLV2}/deal?page=1&limit=1000&campaign_id=22`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessTokenPrivilege}`,
      },
    }).then((res) => {
      if (res.message) {
        //history.push("/logout");
      } else {
        // console.log(res.data.data);
        setListPrivilege(res.data.data)
      }
    }).catch((err) => {
      //window.location.assign("/logout");
    });
  };
  const getUserTarget2 = async (is_delelte = false, conditions_data, key = '') => {
    await templateDate(is_delelte, value, conditions_data, key)
    console.log('conditions_data', conditions_data)
    if (showDate && !is_delelte) {
      if (start_date === undefined || start_date == '' || !start_date) {
        return AlertError("กรุณาใส่วันที่เริ่มต้น !!");
      }
      if (end_date === undefined || end_date == '' || !end_date) {
        return AlertError("กรุณาใส่วันที่สิ้นสุด !!");
      }
    }
    console.log()
    const apiUrls = `${baseURLV1}/targetGroup/preview/user`;
    let token = localStorage.getItem("token");
    let allData = [];
    let temp = []
    if (!is_delelte) {
      localStorage.setItem('temp0', JSON.stringify(conditions))
    } else {
      temp = JSON.parse(localStorage.getItem('temp0')).filter(item => item.key != key)
      localStorage.setItem('temp0', JSON.stringify(temp))
    }
    await axios({
      method: "post",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        conditions: is_delelte ? temp : conditions

      },
    })
      .then((res) => {
        console.log(res.data.data)
        const popupTable = popupTable
        res.data.data.map(data => {
          allData.push(data);
        })
        const check = is_delelte ? temp : conditions
        console.log('check', check.length == 0, check)
        if (check.length == 0) {
          setPopupTable([])

        } else {
          setPopupTable(allData)

        }
      })
      .catch((err) => {
        if (err.response) {

        }
      });
  }

  const columns_m = [
    {
      dataField: "key",
      text: "Key",
      headerStyle: (colum, colIndex) => {
        return { width: "130px" };
      },
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <p>
              {row.label}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "value",
      text: "value",
      headerStyle: (colum, colIndex) => {
        return { width: "100px" };
      },
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <p>
              {row.value}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "start_date",
      text: "start date",
      headerStyle: (colum, colIndex) => {
        return { width: "130px" };
      },
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <p>
              {row.start_date}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "end_date",
      text: "end date",
      headerStyle: (colum, colIndex) => {
        return { width: "130px" };
      },
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <p>
              {row.end_date}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "status",
      text: "status",
      headerStyle: (colum, colIndex) => {
        return { width: "100px" };
      },
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <p>
              {row.status ? 'active' : 'Inactive'}
            </p>
          </div>
        );
      },
    },

    {
      text: " ",
      headerStyle: (colum, colIndex) => {
        return { width: "80px" };
      },
      formatter: (id, row, index) => {
        return (
          <>
            {/*<button
              className="btn btn-light btn-sm mr-1"
              type="button"
              onClick={() => editMemberFields({ id, row, index })}
            >
              <SVG
                src={toAbsoluteUrl('/media/svg/icons/General/Edit.svg')} />
            </button>*/}

            <button
              className="btn btn-danger btn-sm"
              type="button"
              onClick={() => RemoveCondition({ id, row, index })}
            >
              <SVG
                src={toAbsoluteUrl('/media/svg/icons/Home/Trash.svg')} />
            </button>
          </>
        );
      },
    },
  ]

  const columns_popup = [
    {
      dataField: "key",
      text: "user id",
      headerStyle: (colum, colIndex) => {
        return { width: "130px" };
      },
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <p>
              {row.user_id}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "key",
      text: "firstname",
      headerStyle: (colum, colIndex) => {
        return { width: "130px" };
      },
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <p>
              {row.firstname}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "value",
      text: "lastname",
      headerStyle: (colum, colIndex) => {
        return { width: "100px" };
      },
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <p>
              {row.lastname}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "start_date",
      text: "email",
      headerStyle: (colum, colIndex) => {
        return { width: "130px" };
      },
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <p>
              {row.email}
            </p>
          </div>
        );
      },
    },
    {
      dataField: "end_date",
      text: "mobile number",
      headerStyle: (colum, colIndex) => {
        return { width: "130px" };
      },
      //sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      formatter: (id, row, rowIndex) => {
        return (
          <div>
            <p>
              {row.mobile_number}
            </p>
          </div>
        );
      },
    },
  ]

  const RemoveCondition = (items) => {
    Swal.fire({
      title: "",
      text: "ต้องการลบรายการ",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "ลบ",
      cancelButtonText: "ยกเลิก",
    }).then(async (result) => {

      const test = JSON.parse(localStorage.getItem('temp'))
      const test0 = JSON.parse(localStorage.getItem('temp0'))
      if (result.value) {
        setMemberData(test.filter(item => item.key != items.row.key))
        localStorage.setItem('temp', JSON.stringify(test.filter(item => item.key != items.row.key)))
        console.log('zzz', conditions, test0, conditions.filter(item => item.key != items.row.key))
        Swal.fire("", "ทำการลบรายการสำเร็จ", "success");
        await getUserTarget2(true, conditions, items.row.key)
        //Swal.fire("", "ทำการลบรายการสำเร็จ", "success");
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("", "ยกเลิกการลบรายการ ", "error");
      }
    });

  };

  const getCount = (data) => {
    if (data % 10 > 0) {
      return Math.floor(data / 10) + 1
    } else {
      return Math.floor(data / 10)
    }
  }


  const [groupName, setGroupName] = useState([]);
  const [listDeal, setListDeal] = useState([]);
  const [value, setValue] = useState([]);
  const { user, authToken, accessTokenPrivilege } = useSelector((state) => state.auth);

  const AlertError = (message) => {
    Swal.fire("", message, "error");
  };

  const getListGroup = async () => {
    const apiUrls = `${baseURLV1}/configCondition`;
    let token = localStorage.getItem("token");
    let allData = [];

    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        console.log(res.data.data)
        res.data.data.map(data => {
          data = {
            id: data.id,
            created_at: data.created_at,

            key: data.key,
            option: data.option,
            value: data.value,
            label: data.label,
            updated_at: data.updated_at,
            description: data.description,

          };
          allData.push(data);
        })
        fixedlist.map(item => {
          allData.push(item)
        })
        setListGroup2(allData)
      })
      .catch((err) => {
        if (err.response) {

        }
      });
  };

  const getBrand = async () => {
    const apiUrls = `${baseURLV1}/brand`;
    let token = localStorage.getItem("token");
    let allData = [];

    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        console.log(res.data.data)
        res.data.map(data => {

          allData.push(data);
        })

        setBrandtList(allData)
      })
      .catch((err) => {
        if (err.response) {

        }
      });
  };

  const getProject = async () => {
    const apiUrls = `${baseURLV1}/project`;
    let token = localStorage.getItem("token");
    let allData = [];

    axios({
      method: "get",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        console.log(res.data.data)
        res.data.map(data => {

          allData.push(data);
        })

        setProjectList(allData)
      })
      .catch((err) => {
        if (err.response) {

        }
      });
  };


  useEffect(() => {
    getListTarget()
    getListGroup()
    getBrand()
    getProject()
    getListPrivilege()
  }, []);

  const getShowsplit = (data) => {
    let string = ''
    data.map(item => {
      if (string == '') {
        string = string + `${item.label}`
      } else {
        string = string + ` ,${item.label}`
      }
    })
    return string
  }
  const onlyUnique = (value, index, self) => {
    return self.indexOf(value) === index;
  }
  const addMember = async () => {
    setIs_loading(true)
    try {

      console.log(groupName.length, groupName);
      if (groupName.length == 0 || groupName === undefined) {
        setIs_loading(false)
        return AlertError("กรุณาใส่ชื่อกลุ่ม !!");
      }
      if (value.length == 0 || value === undefined) {
        if (groupName.value) {
          return AlertError("กรุณาใส่ค่า !!");

        }
      }
      if (showDate) {
        if (start_date === undefined || start_date == '' || !start_date) {
          return AlertError("กรุณาใส่วันที่เริ่มต้น !!");
        }
        if (end_date === undefined || end_date == '' || !end_date) {
          return AlertError("กรุณาใส่วันที่สิ้นสุด !!");
        }
      }
      if (titleTH.length > 0 && titleEN.length > 0) {
        if (titleTH === undefined || titleTH == '' || !titleTH) {
          return AlertError("กรุณาใส่ชื่อกลุ่มเป้าหมาย (TH) !!");
        }
        if (titleEN === undefined || titleEN == '' || !titleEN) {
          return AlertError("กรุณาใส่ชื่อกลุ่มเป้าหมาย (EN) !!");
        }
      }
      await getUserTarget2(false, conditions)


      var data_all = [];

      let data = {


        key: groupName.key,
        label: groupName.label,
        value: getShowsplit(value),
        start_date: start_date,
        end_date: end_date,
        status: is_active,

      }


      data_all.push(...memberData, data)
      localStorage.setItem('temp', JSON.stringify(data_all))
      setMemberData(data_all);
      setExcelData()
      setGroupName([])
      setValue([])
      setStart_date(null)
      setEnd_date(null)
      setShowDate(false)
      setShowListValue(false)
      //console.log('conditions', conditions)
      setIs_loading(false)
    } catch {
      setIs_loading(false)
    }
  };

  const checkOption = async (data) => {
    let count = 0
    data.map(item => {
      item.option.map(item2 => {

        if (item2 == item.value) {
          count++;
          console.log(count)
        }
        if (count > 0) {
          return true
        }
      })
    })


    return false

  }

  const templateDate = (is_delete = false, value, condition_data, key) => {
    let template = condition_data
    console.log('template', template)
    let temp = []
    let option = {}
    value.map(item2 => {

      temp.push(item2.value)

    })

    if (!is_delete) {
      template.push({
        key: groupName.key,
        condition: '=',
        value: temp,
        ...showDate ? { options: { dateFrom: start_date, dateTo: end_date } } : {}
      })
      //localStorage.setItem('template0', JSON.stringify(template))
    } else {
      template = JSON.parse(localStorage.getItem('temp0')).filter(item => item.key != key)
    }
    //if (checkOption(value)) console.log('option')
    console.log('xa', template)
    setConditions(template)

  }

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    //getData(1, event.target.value, search);
  };

  const onSubmit = async () => {
    let dateFrom = {}
    let dateTo = {}
    let template = []

    console.log(conditions)
    if (titleTH === undefined || titleTH === '') {
      return AlertError("กรุณาใส่ ชื่อกลุ่มเป้าหมาย th !!");
    }
    if (titleEN === undefined || titleEN === '') {
      return AlertError("กรุณาใส่ ชื่อกลุ่มเป้าหมาย en !!");
    }


    var events = {
      name_th: titleTH,
      name_en: titleEN,
      group_condition_id: target,
      deal_ids: listDeal,
    };

    let apiUrls = `${baseURLV1}/targetGroupPvl`;
    let token = localStorage.getItem("Token");
    const resultAll = axios({
      method: "post",
      url: apiUrls,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: events,
    })
      .then(async (res) => {
        history.goBack();
      })
      .catch((err) => {
        Swal.fire(
          "Alert",
          "ไม่สามารถสร้าง Target Group. !! " + err,
          "error"
        );
      });
  };


  return (
    <>
      <Card>
        <CardHeader title="Create Privilege Target Group"></CardHeader>
        <CardBody>
          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "ชื่อกลุ่มรีวอร์ด (TH)" })}<span style={{ color: "red" }}>
                *
              </span>:{" "}
            </p>
            <input
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={titleTH}
              onChange={(e) => setTitleTH(e.target.value)}
            />

          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "ชื่อกลุ่มรีวอร์ด (EN)" })}<span style={{ color: "red" }}>
                *
              </span>:{" "}
            </p>
            <input
              name="modelGroup"
              style={{
                height: "38px",
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              value={titleEN}
              onChange={(e) => setTitleEN(e.target.value)}
            />

          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>
              <span style={{ color: "red" }}>

              </span>
              {intl.formatMessage({ id: "###", defaultMessage: "กลุ่มเป้าหมาย" })}:{" "}
            </p>
            <select name="cars" id="cars"
              style={{ width: "530px" }}
              value={target}
              onChange={(e) => {
                // console.log(e.target.value)
                setTarget(e.target.value)
              }}
            >
              <option value={null}>
                All
              </option>
              {listTarget &&
                listTarget.map((result, index) => {
                  return (
                    <option key={index} value={result.id}>
                      {result.title_th}
                    </option>
                  );
                })}

            </select>
          </div>

          <div className="form-inline" style={{ marginBottom: "25px" }}>
            <p style={{ marginTop: "15px", float: "left", width: "20%" }}>

              {intl.formatMessage({ id: "###", defaultMessage: "เลือกรีวอร์ด" })}<span style={{ color: "red" }}>
                *
              </span>:{" "}
            </p>
            <Autocomplete
              multiple
              id="grouped-demo"
              options={listPrivilege}
              getOptionLabel={(option) => option.deal_name}
              getOptionSelected={(option, value) => option.id === value.id}
              value={groupName}
              onChange={(event, newValue) => {
                console.log('x', newValue)
                console.log('y', event)
                setGroupName(newValue)
                let temp = []
                newValue.map(item=> {
                  temp.push(item.id)
                })
                setListDeal(temp)
              }}
              style={{
                width: "530px",
                backgroundColor: "#F4F6F9",
                borderRadius: "5px",
                borderWidth: "0",
              }}
              renderInput={(params) =>
                <TextField {...params} variant="outlined" />
              }
            />
            {groupName.description && (<button
              className="btn btn-transparent btn-sm ml-2"
              type="button"
              onClick={() => {
                console.log('groupName', groupName)
                setshow2(true)
                let temp = []
                try {
                  temp = JSON.parse(groupName.description)
                  console.log(JSON.parse(groupName.description))
                } catch {

                }
                console.log(temp)
                setInfo(temp)
              }}
            >
              <SVG
                style={{ width: '30px', height: '30px' }}
                src={toAbsoluteUrl('/media/svg/icons/Home/info.svg')} />
            </button>)}

          </div>


          <div
            className="form-inline"
            style={{
              marginBottom: "25px",
            }}
          >
            <div
              style={{
                marginTop: "15px",
                float: "left",
                width: "20%",
              }}
            ></div>
            <Link to="/TargetGroupPrivilege">
              <button type="button" className="btn btn-secondary wbt mr-5">
                {intl.formatMessage({ id: "###", defaultMessage: "Cancel" })}
              </button>
            </Link>
            <button className="btn btn-primary" onClick={() => onSubmit()}>
              {intl.formatMessage({ id: "###", defaultMessage: "Save" })}
            </button>
          </div>
          <Modal show={show} onHide={handleClose} animation={false} size={'lg'}>
            <Modal.Header closeButton>
              <Modal.Title>ตารางกลุ่มผู้ใช้</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="m-5">
                <Card>
                  <BootstrapTable
                    keyField="id"
                    data={popupTable.filter((data, index) => {
                      return data == data && index + 1 > (page * 10) - 10 && index + 1 < (page * 10) + 1
                    })}
                    columns={columns_popup}
                    wrapperClasses="table-responsive"
                    bordered={false}
                    classes="table table-head-custom table-vertical-center overflow-hidden"
                    bootstrap4
                  />
                  <div className=" col-lg-12">
                    <div className="row">
                      {/*<div className="col-lg-6">
                        <div className="mt-3">
                          {"Items per Page: "}
                          <select onChange={handlePageSizeChange} value={10}>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </select>
                        </div>
                      </div>*/}
                      <div className="col-lg-6 d-flex align-items-center">
                        <Pagination2
                          className="mt-3 "
                          count={getCount(popupTable.length)}
                          page={page}
                          siblingCount={1}
                          boundaryCount={1}
                          variant="outlined"
                          shape="rounded"
                          onChange={handlePageChange}
                        />
                        <span class="mt-3 ml-5">Result : {popupTable.length} records</span>
                      </div>
                    </div>
                  </div>
                </Card>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                ปิด
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal show={show2} onHide={handleClose2} animation={false} size={'lg'}>
            <Modal.Header closeButton>
              <Modal.Title>รายละเอียด</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="m-5">
                {
                  info && info.map((item) => {
                    return (
                      <p>{item.value}  -  {item.label}</p>
                    )
                  })
                }
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose2}>
                ปิด
              </Button>
            </Modal.Footer>
          </Modal>

        </CardBody>
      </Card>
    </>
  );
};
